import {  NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductDetailRoutingModule } from './product-detail-routing.module';
import { ProductDetailComponent } from './product-detail.component';
import { SharedModule } from '../shared/shared.module';
import { GlobalLoginModule } from '../global/global-login/global-login.module';

import { NgxImageZoomModule } from 'ngx-image-zoom';
import { CardModule } from 'primeng/card';
import { KnobModule } from 'primeng/knob';
import { GalleriaModule } from 'primeng/galleria';
import { SidebarModule } from 'primeng/sidebar';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { ToastModule } from 'primeng/toast';
import { DialogModule } from 'primeng/dialog';
import { CheckboxModule } from 'primeng/checkbox';
import { ShareButtonsModule } from 'ngx-sharebuttons/buttons';
import { ShareIconsModule } from 'ngx-sharebuttons/icons';
@NgModule({
  declarations: [
    ProductDetailComponent
  ],
  imports: [
    CommonModule,
    ProductDetailRoutingModule,
    GlobalLoginModule,
    NgxImageZoomModule,
    CardModule,
    KnobModule,
    GalleriaModule,
    SharedModule,
    SidebarModule,
    ScrollPanelModule,
    ToastModule,
    DialogModule,
    CheckboxModule,
    ShareButtonsModule.withConfig({
              debug:true
            }), 
            ShareIconsModule,
  ],
  providers:[],
})
export class ProductDetailModule { }
